import React, { useEffect, useState } from "react";
import Layout from "../../common/Layout";
import PropTypes from "prop-types";
import AddItemButton from "../../common/components/base/AddItemButton";
import ItemsGrid from "../../common/components/widgets/ItemsGrid";
import Swal from 'sweetalert2';
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
// import { useMutation, useQuery } from "@apollo/client"; // TODO: Replaced with REST hooks
// import { client } from "../../settings/apollo"; // TODO: Replaced with REST hooks
// import { getBannerDefinitions, GET_BANNERS_DEFINITIONS } from "./graphql/queries"; // TODO: Replaced with REST hooks
// import { DELETE_BANNER } from "./graphql/mutations"; // TODO: Replaced with REST hooks
import { useBanners } from "../../hooks/useBanners";
import { useDeleteBanner } from "../../hooks/useDeleteBanner";
import AdminSettingsNavigation from '../adminSettings/AdminSettingsNavigation';

const columns = ["title", "sections",  "action"];
const columnsName = ["title", "sections" ,"action" ]

const BannersList = (props) => {
  BannersList.propTypes = {
    page: PropTypes.number,
    name: PropTypes.string
  }
  const [banners, setBanners] = useState([]);
  const deleteBannerMutation = useDeleteBanner();
  const { data, isLoading: loading, error } = useBanners();

  useEffect(() => {
    if (data?.bannerDefinitions) {
      setBanners(data.bannerDefinitions);
    }
  }, [data]);

  const removeBanner = (id) => {
    const index = banners.findIndex((item) => {
      return (item.key === id);
    });
    const clonedBanners=[...banners];
    clonedBanners.splice(index,1);
    setBanners(clonedBanners)
  }

   const remove = (item) => {
    Swal.fire({
      title: 'Are you sure you want to delete this banner?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      }
    }).then((result) => {
      if (result.value===true) {
        deleteBannerMutation.mutate(item.key, {
          onSuccess: (data) => {
            if (data.deleteBanner) {
              Swal.fire({
                type: 'success',
                title: 'Banner deleted!',
                showConfirmButton: false,
                timer: 1500
              })
              .then((result)=> { 
                if(result.dismiss==='timer') removeBanner(item.key) 
              });
              // Data will be automatically refetched due to query invalidation in the hook
            }
          },
          onError: (error) => {
            Swal.fire({
              type: 'error',
              title: 'Error deleting banner',
              showConfirmButton: false,
              timer: 1500
            });
            console.log(error);
          }
        });
      }
    })
  }

  const edit = (item) => {
    props.history.push(`/admin-settings/banners/${item.key}`)
  }

  const create = () => {
    props.history.push(`/admin-settings/banners/create`)
  }

  return (
    <Layout name="Banner List">
      <div className="wizard-container">
          <AddItemButton OnClick={()=>create()} />
            <AdminSettingsNavigation path={props.match.path} />
            { loading && (<LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />) }
            { error && (<div>`Error! ${error.message}`</div>) }
            { !banners && (<div>No Banners available</div>) }
            { banners &&
               (<div>
                  <ItemsGrid
                    columns={columns}
                    columnsName={columnsName}
                    remove={(index, value)=>remove(value)}
                    edit={(index, value)=>edit(value)}
                    title={"Banners"}
                    items={banners}
                    pagination={true}
                    />
                </div>
              )}
      </div>
    </Layout>
  );
}

export default BannersList;
